module.exports = __webpack_public_path__ + "img/bai-driver-ios.e23217a8.png";